










































import { Component, Inject, Prop, Watch, Vue } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";

import FormErrors from "@/lib/components/FormErrors.vue";
import ListItemPageNavigation from "@/lib/components/ListItemPageNavigation.vue";
import LoadingSpinner from "@/lib/components/LoadingSpinner.vue";

import { Dictionary } from "@/lib/Dictionary.type";
import dataStore from "@/store";
import AuthenticatedUserProvider from "@/modules/account/authenticated-user-provider.service";
import { Resource } from "@/modules/account/resource";
import ErrorConverterService from "@/modules/forms/error-converter.service";
import PlushieStore from "@/modules/plushie/store";

import ProductGroupForm from "./Form.vue";

import FactoryRushCapacityProductGroup from "../../factory-rush-capacity-product-group.model";
import FactoryRushCapacityStore from "../../store";

@Component({
  metaInfo() {
    const component = this as FactoryRushCapacityProductGroupEditPage;

    return {
      title: component.pageTitle,
    };
  },
  components: {
    FormErrors,
    ListItemPageNavigation,
    LoadingSpinner,
    ProductGroupForm,
  },
})
export default class FactoryRushCapacityProductGroupEditPage extends Vue {
  @Prop({ required: true })
  public readonly groupId!: string;

  @Prop({ default: () => ({}) })
  public readonly query!: Dictionary<unknown>;

  @Prop({ default: () => ({}) })
  public readonly listQuery?: Dictionary<string[]>;

  @Inject("AuthenticatedUserProvider")
  private fUserProvider!: AuthenticatedUserProvider;

  @Inject("ErrorConverterService")
  private fErrorConverterService!: ErrorConverterService;

  private fErrorsList: string[] = [];
  private fFactoryRushCapacityStore: FactoryRushCapacityStore;
  private fIsLoading = false;
  private fPlushieStore: PlushieStore;

  get canAccessProductGroups(): boolean {
    return this.canManageProductGroups || this.canViewProductGroups;
  }

  get canManageProductGroups(): boolean {
    const user = this.fUserProvider.getUser();

    return (
      user !== undefined &&
      user.hasPermissionForResource(Resource.FACTORY_RUSH_CAPACITY_MANAGE)
    );
  }

  get canViewProductGroups(): boolean {
    const user = this.fUserProvider.getUser();

    return (
      user !== undefined &&
      user.hasPermissionForResource(Resource.FACTORY_RUSH_CAPACITY_VIEW)
    );
  }

  get errorsList(): string[] {
    return this.fErrorsList;
  }

  get group(): FactoryRushCapacityProductGroup | undefined {
    return this.fFactoryRushCapacityStore.getFactoryRushCapacityProductGroupById(
      this.groupId
    );
  }

  get isLoading(): boolean {
    return this.fIsLoading;
  }

  get pageTitle(): string {
    return `${
      this.canManageProductGroups ? "Edit" : "View"
    } Rush Product Group`;
  }

  constructor() {
    super();

    this.fFactoryRushCapacityStore = getModule(
      FactoryRushCapacityStore,
      dataStore
    );
    this.fPlushieStore = getModule(PlushieStore, dataStore);
  }

  public async getGroupsOrder(): Promise<string[]> {
    await this.fFactoryRushCapacityStore.loadFactoryRushCapacityProductGroups();

    return this.fFactoryRushCapacityStore.allFactoryRushCapacityProductGroupsList.map(
      (group) => group.id
    );
  }

  public onCancel(): void {
    this.openList();
  }

  public onSaved(): void {
    this.openList();
  }

  private async loadGroup(): Promise<void> {
    if (!this.groupId || !this.canAccessProductGroups) {
      return;
    }

    this.fErrorsList = [];
    this.fIsLoading = true;

    try {
      await Promise.all([
        this.fFactoryRushCapacityStore.loadFactoryRushCapacityProductGroups({
          useCache: false,
        }),
        this.fFactoryRushCapacityStore.loadFactoryRushCapacityProductGroupMembers(
          { useCache: false }
        ),
        this.fPlushieStore.loadProducts(),
      ]);

      if (!this.group) {
        this.fErrorsList = ["Rush Product Group was not found."];
      }
    } catch (error) {
      this.fErrorsList = this.fErrorConverterService.describeError(error);
    } finally {
      this.fIsLoading = false;
    }
  }

  private openList(): void {
    void this.$router.push({
      name: "FactoryRushCapacityProductGroupsListPage",
      query: this.listQuery,
    });
  }

  @Watch("groupId", { immediate: true })
  private _onGroupIdChange(): void {
    void this.loadGroup();
  }
}
